import React from 'react';
import { Fragment, useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { Row, Alert } from 'react-bootstrap';
import FormBusca from './form_busca';
import ContasService from '../../../../services/prest-contas-auth';
import Documento from './documento';


const ListarDocumentos = () => {

    const [documentos, setDocs] = useState([]);
    const [editar, setEditar] = useState("");
    const [vazio, setVazio] = useState(false);
    const [documento, setDoc] = useState("");


    async function fetchDocumentos() {
        const response = await ContasService.listar();
        if (response.data.length >= 1) {
            setDocs(response.data)
            setVazio(false)
        } else {
            setDocs([])
            setVazio(true)
        }
    }

    const handleEditar = (id) => {
        setDoc(id);
        setEditar(true)
    }


    const deletar = async (id) => {
        if (window.confirm('Tem certeza que deseja deletar o documento?')) {
            await ContasService.deletar(id)
            alert("Documento deletado com sucesso!")
            fetchDocumentos();
        }
    }

    useEffect(() => {
        fetchDocumentos();
    }, []);



    if (editar) {
        return (
            <Navigate to={`/restrito/contas/editar/${documento}`} />
        )
    }
    else {
        return (
            <Fragment>
                <Fragment>
                    <FormBusca
                        setDocs={setDocs}
                        setVazio={setVazio}
                        fetchDocumentos={fetchDocumentos}
                    />
                </Fragment>
                {vazio ? <Fragment>
                    <Alert variant='danger'>Sua busca não gerou nenhum resultado :(</Alert>
                </Fragment> :
                    <Fragment>
                        <Row xs={1} lg={3}>
                            {documentos.map((documento, index) =>
                                <Documento
                                    fetchDocumentos={fetchDocumentos}
                                    documento={documento}
                                    key={index}
                                    editar={handleEditar}
                                    deletar={deletar}
                                />
                            )}
                        </Row>
                    </Fragment>}
            </Fragment>

        )
    }
}

export default ListarDocumentos;